import { useMemo } from 'react'
import { useDispatch } from 'react-redux'
import { useSelector } from 'src/utils/store'
import { actions } from '../../ShedManagementState'
import { SelectedLocations } from '../../ShedManagementTypes'
import TableMui from 'src/components/TableMui'

interface Props {
  maxHeight?: string
}

const LocationsTable = ({ maxHeight }: Props) => {
  const { selectedLocations, locationHeightTypes, locations } = useSelector((state) => state.shedManagement)
  const dispatch = useDispatch()

  const rows = useMemo(() =>
    locations.map(({
      id, shed, street, shelf, bin, idLocationHeightType, isGondola, isFresh,
    }) => {
      const heightType = locationHeightTypes.find((location) => location.id === idLocationHeightType)

      return {
        id,
        shed,
        street,
        shelf,
        bin,
        idLocationHeightType: heightType?.name || '-',
        isGondola: isGondola ? 'Sim' : 'Não',
        isFresh: isFresh ? 'Sim' : 'Não',
      }
    }), [locationHeightTypes, locations])

  const handleSelectAllClick = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.checked) {
      const newSelected = rows.map((row) => {
        const currentLocation = locations.find((location) => location.id === row.id)

        return {
          id: row.id,
          isGondola: currentLocation?.isGondola || false,
          isFresh: currentLocation?.isFresh || false,
          idLocationHeightType: currentLocation?.idLocationHeightType || null,
          locationAttribute: currentLocation?.locationAttribute || [],
        }
      })
      dispatch(actions.setSelectedLocations({ selectedLocations: newSelected }))
      return
    }
    dispatch(actions.setSelectedLocations({ selectedLocations: [] }))
  }

  const handleClick = (id: number) => {
    const selectedIndex = selectedLocations.findIndex((location) => location.id === id)

    if (selectedIndex === -1) {
      const locationFromLocations = locations.find((location) => location.id === id)

      if (locationFromLocations) {
        const locationToAdd: SelectedLocations = {
          id,
          isGondola: locationFromLocations.isGondola,
          isFresh: locationFromLocations.isFresh,
          idLocationHeightType: locationFromLocations.idLocationHeightType,
          locationAttribute: locationFromLocations.locationAttribute,
        }
        dispatch(actions.setSelectedLocations({ selectedLocations: [...selectedLocations, locationToAdd] }))
      }
    } else {
      const updatedSelectedLocations = selectedLocations.filter((location) => location.id !== id)
      dispatch(actions.setSelectedLocations({ selectedLocations: updatedSelectedLocations }))
    }
  }

  return (
    <TableMui
      columns={[
        { id: 'shed', label: 'Galpão' },
        { id: 'street', label: 'Rua' },
        { id: 'shelf', label: 'Estante' },
        { id: 'bin', label: 'Escaninho' },
        { id: 'idLocationHeightType', label: 'Altura' },
        { id: 'isGondola', label: 'É gôndola' },
        { id: 'isFresh', label: 'É fresh' },
      ]}
      emptyLabel='Utilize o filtro para buscar localizações'
      rows={rows}
      rowCount={rows.length}
      selectedCount={selectedLocations.length}
      enablePagination
      rowsPerPageLimit={50}
      rowsPerPageOptions={[5, 10, 25, 30, 50, 100, 200]}
      selected={selectedLocations.map((item) => item.id)}
      onSelectAllClick={handleSelectAllClick}
      onRowClick={handleClick}
      maxHeight={maxHeight}
      width='55%'
      hasCheckbox
      hasSorting
      testId='locations-table-test'
    />
  )
}

export default LocationsTable
